export default __webpack_public_path__ + "static/media/aws.01a3e411.svg";